import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "ts at-userroles mt-2"
};
const _hoisted_3 = {
  class: "ts table stylized at-rolestable"
};
const _hoisted_4 = {
  class: "client-header"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "fa fa-chevron-right"
};
const _hoisted_7 = {
  class: "fa fa-chevron-down"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "at-sublabel"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_LlCheckbox = _resolveComponent("LlCheckbox");
  const _component_product_notice = _resolveComponent("product-notice");
  const _component_settings_save_bar = _resolveComponent("settings-save-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "User Permissions"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, (role, idx) => {
    return _openBlock(), _createElementBlock("td", {
      class: _normalizeClass(["at-roleslabel", {
        'primary-table-cell': role.id == 'primary'
      }]),
      key: idx,
      style: {
        "text-align": "center"
      }
    }, _toDisplayString(role.label), 3);
  }), 128))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.permissions, (permission, idx) => {
    return _openBlock(), _createElementBlock("tbody", {
      key: idx
    }, [_createElementVNode("tr", _hoisted_4, [_createElementVNode("td", {
      onClick: $event => permission.expanded = !permission.expanded
    }, [_withDirectives(_createElementVNode("span", _hoisted_6, null, 512), [[_vShow, !permission.expanded]]), _withDirectives(_createElementVNode("span", _hoisted_7, null, 512), [[_vShow, permission.expanded]])], 8, _hoisted_5), _createElementVNode("td", {
      onClick: $event => permission.expanded = !permission.expanded,
      class: "at-permissionlabel"
    }, [_createElementVNode("b", null, _toDisplayString(permission.label), 1), permission.id === 'billing' ? (_openBlock(), _createBlock(_component_LlTooltip, {
      key: 0,
      icon: "help",
      class: "ml-1"
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Users with access to view and edit invoices will be able to see and edit the rates of time entries on those invoices regardless of their other rate related permissions. ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)], 8, _hoisted_8), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, (role, idx) => {
      return _openBlock(), _createElementBlock("td", {
        class: _normalizeClass(["at-checkbox-{{role.id}}", {
          'vertical-divider-left': role.id == 'primary'
        }]),
        key: idx,
        style: {
          "text-align": "center"
        }
      }, [_createVNode(_component_LlCheckbox, {
        "model-value": permission.roles[role.id],
        indeterminate: typeof permission.roles[role.id] !== 'boolean',
        "aria-label": `${permission.label} for ${role.label}`,
        disabled: !$data.me.features.permissions,
        class: "d-inline-flex",
        "onUpdate:modelValue": value => $options.handleClickFromCheckbox(value, {
          permission,
          role,
          main: true
        })
      }, null, 8, ["model-value", "indeterminate", "aria-label", "disabled", "onUpdate:modelValue"])], 2);
    }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.permissions, (sub, idx) => {
      return _withDirectives((_openBlock(), _createElementBlock("tr", {
        key: idx,
        class: "subrow"
      }, [_cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)), _createElementVNode("td", _hoisted_9, [_createTextVNode(_toDisplayString(sub.label) + " ", 1), sub.description ? (_openBlock(), _createBlock(_component_LlTooltip, {
        key: 0,
        icon: "help"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(sub.description), 1)]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, (role, idx) => {
        return _openBlock(), _createElementBlock("td", {
          class: _normalizeClass(["at-checkbox-{{role.id}}", {
            'vertical-divider-left': role.id == 'primary'
          }]),
          key: idx,
          style: {
            "text-align": "center"
          }
        }, [_createVNode(_component_LlCheckbox, {
          "model-value": sub.roles[role.id],
          "aria-label": `${sub.label} for ${role.label}`,
          disabled: !$data.me.features.permissions || sub.locked,
          class: "d-inline-flex",
          "onUpdate:modelValue": value => $options.handleClickFromCheckbox(value, {
            permission,
            sub,
            role,
            subrow: true
          })
        }, null, 8, ["model-value", "aria-label", "disabled", "onUpdate:modelValue"])], 2);
      }), 128))])), [[_vShow, permission.expanded]]);
    }), 128))]);
  }), 128))])]), _cache[6] || (_cache[6] = _createElementVNode("h3", null, null, -1)), _createVNode(_component_product_notice, {
    state: $data.state,
    product: 'permissions',
    label: 'This ability to adjust user permissions is'
  }, null, 8, ["state"]), _createVNode(_component_settings_save_bar, {
    somethingChanged: $data.formChanged && $data.me.features.permissions,
    saving: $data.saving,
    unsaved: $data.unsaved,
    onUpdate: _cache[0] || (_cache[0] = $event => $options.save()),
    onCancel: _cache[1] || (_cache[1] = $event => $options.cancel())
  }, null, 8, ["somethingChanged", "saving", "unsaved"])]);
}